<p-card class="p-card-content--no-padding">
  <ng-template pTemplate="header">
    <legend class="flex flex-wrap p-3 pb-0">Referral Program</legend>
  </ng-template>
  Know somebody (or a whole listserv) that our system would be a great fit for? Take advantage of our referral program
  <a href="https://share.hsforms.com/1rRo4F4kxSlqcM-DUFXWiXg4cjdz">here</a>. Questions? Just email us at
  <span class="word-break-mobile-only">customerservice&#64;helplinesoftware.com</span>
</p-card>
